{
  "familyId": "SPR-WEET-EI-IJ",
  "questions": [
    {
      "id": "SPR-WEET-EI-IJ-001",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "multiple_choice",
      "question": "Welk van deze woorden schrijf je met 'ij' (en níet met 'ei')?",
      "context": "De woorden klinken hetzelfde, maar je schrijft ze anders. Je moet ze uit je hoofd leren.",
      "options": ["vrij", "klein", "trein", "meisje"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "EI of IJ?",
            "content": "Ij-woorden om te onthouden: vrij, tijd, rijden, schrijven, blij, wijs. Ei-woorden om te onthouden: klein, trein, meisje, reis, leiden. De klank is hetzelfde — je moet het uit je hoofd leren.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_kies_ij_woord",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Vrij' schrijf je met 'ij'. De andere drie woorden — klein, trein, meisje — schrijf je allemaal met 'ei'. Omdat ei en ij hetzelfde klinken, moet je deze weetwoorden uit je hoofd leren.",
        "solutionSteps": [
          "Vrij → ij-woord ✓",
          "Klein → ei-woord",
          "Trein → ei-woord",
          "Meisje → ei-woord",
          "Antwoord: vrij"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vrij' is een ij-woord. Andere ij-woorden: tijd, rijden, schrijven, blij.",
          "1": "'Klein' schrijf je met 'ei', niet met 'ij'. Onthoud: klein hoort in het rijtje trein, meisje, reis.",
          "2": "'Trein' schrijf je met 'ei', niet met 'ij'. Onthoud: trein hoort in het rijtje klein, meisje, reis.",
          "3": "'Meisje' schrijf je met 'ei', niet met 'ij'. Onthoud: meisje hoort in het rijtje trein, klein, reis."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.ei-ij-confusion", "label": "Denkt dat 'klein' met ij wordt geschreven", "optionIndex": 1 },
          { "id": "spr.ei-ij-confusion", "label": "Denkt dat 'trein' met ij wordt geschreven", "optionIndex": 2 },
          { "id": "spr.ei-ij-confusion", "label": "Denkt dat 'meisje' met ij wordt geschreven", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-002",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout en verbeter het woord.",
      "data": {
        "text": "Het is bijsonder mooi weer vandaag.",
        "errors": [
          {
            "word": "bijsonder",
            "position": 2,
            "correction": "bijzonder",
            "explanation": "'Bijzonder' schrijf je met een 'z'. Het voorvoegsel 'bij-' is altijd met 'ij', en 'zonder' begint met een 'z'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "IJ or EI?",
            "content": "'Bijzonder' schrijf je met 'ij'. Dit is een weetwoord. Tip: 'bij' is een voorvoegsel dat altijd met 'ij' geschreven wordt (bijv. bijzonder, bijvoorbeeld, bijdrage).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_bijzonder",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Bijzonder' schrijf je met 'ij' en een 'z'. Het voorvoegsel 'bij-' wordt altijd met 'ij' geschreven, en het basiswoord is 'zonder' (met z). Door het woord in een zin te lezen, kun je de fout beter herkennen. Andere voorbeelden: bijvoorbeeld, bijdrage, bijzin.",
        "solutionSteps": [
          "Lees de zin en zoek het woord dat er niet goed uitziet",
          "'Bijsonder' ziet er fout uit — klopt de 's'?",
          "Het basiswoord is 'zonder' (met z), niet 'sonder'",
          "Verbetering: bijzonder (bij + zonder)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-003",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "error_spotting",
      "question": "Zoek de spelfout en verbeter het woord.",
      "data": {
        "text": "Ijgenlijk vind ik dit heel leuk.",
        "errors": [
          {
            "word": "Ijgenlijk",
            "position": 0,
            "correction": "Eigenlijk",
            "explanation": "'Eigenlijk' begint met 'ei', niet met 'ij'. Het basiswoord is 'eigen' — dat schrijf je altijd met 'ei'."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "EI of IJ?",
            "content": "'Eigenlijk' schrijf je met 'ei'. Dit is een weetwoord. Tip: 'eigen' begint altijd met 'ei' (bijv. eigenaar, eigendom, eigenlijk).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_eigenlijk",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Eigenlijk' schrijf je met 'ei'. Het basiswoord is 'eigen', en dat begint altijd met 'ei'. Door het woord in een zin te lezen, kun je de fout beter herkennen. Andere voorbeelden: eigenaar, eigendom, eigenwijs — allemaal met 'ei'.",
        "solutionSteps": [
          "Lees de zin en zoek het woord dat er niet goed uitziet",
          "'Ijgenlijk' ziet er fout uit — klopt de 'ij'?",
          "Het basiswoord is 'eigen' — dat begint altijd met 'ei'",
          "Verbetering: Eigenlijk (eigen + lijk)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-004",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: b_zonder (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["bijzonder"],
        "caseSensitive": false,
        "placeholder": "b...zonder"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Voorvoegsel bij-",
            "content": "Het voorvoegsel 'bij-' schrijf je altijd met 'ij': bijzonder, bijvoorbeeld, bijdrage.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_bij",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Bijzonder' schrijf je met 'ij'. Het voorvoegsel 'bij-' wordt altijd met 'ij' geschreven. Andere voorbeelden: bijvoorbeeld, bijdrage, bijzin. Onthoud: bij = altijd ij.",
        "solutionSteps": [
          "Herken het voorvoegsel: 'bij-'",
          "'Bij-' schrijf je altijd met ij",
          "De rest: 'zonder' (met z)",
          "Dus: bijzonder"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-005",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: _genlijk (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["eigenlijk"],
        "caseSensitive": false,
        "placeholder": "...genlijk"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eigen met ei",
            "content": "'Eigen' begint altijd met 'ei': eigenaar, eigendom, eigenlijk.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_eigen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Eigenlijk' schrijf je met 'ei'. Het woord 'eigen' begint altijd met 'ei'. Andere voorbeelden: eigenaar, eigendom, eigenwijs. Onthoud: eigen = altijd ei.",
        "solutionSteps": [
          "Het woord begint met 'eigen'",
          "'Eigen' schrijf je altijd met ei",
          "Achtervoegsel: '-lijk'",
          "Dus: eigenlijk"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-006",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Schrijf het woord correct: vr_heid (met ei of ij). Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["vrijheid"],
        "caseSensitive": false,
        "placeholder": "vr...heid"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vrij met ij",
            "content": "'Vrij' schrijf je altijd met 'ij': vrijheid, vrijdag, bevrijding.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "ei_ij_fill_vrij",
      "variantIndex": 6,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vrijheid' schrijf je met 'ij'. Het woord 'vrij' wordt altijd met 'ij' geschreven. Andere voorbeelden: vrijdag, bevrijding, vrijwillig. Onthoud: vrij = altijd ij.",
        "solutionSteps": [
          "Het woord bevat 'vrij'",
          "'Vrij' schrijf je altijd met ij",
          "Achtervoegsel: '-heid'",
          "Dus: vrijheid"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-007",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: schrijf je ze met 'ei' of met 'ij'?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Met ei", "Met ij"],
        "items": [
          { "text": "tr__n", "correctCategory": 0 },
          { "text": "vr__", "correctCategory": 1 },
          { "text": "kl__n", "correctCategory": 0 },
          { "text": "r__den", "correctCategory": 1 },
          { "text": "m__sje", "correctCategory": 0 },
          { "text": "schr__ven", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ei of ij?", "content": "Ei-woorden: trein, klein, meisje, reis, leiden.\nIj-woorden: vrij, rijden, schrijven, tijd, wijs.\n\nDit zijn weetwoorden — je moet ze uit je hoofd leren.", "icon": "book" } }
      ],
      "conceptId": "ei_ij_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Met ei: trein, klein, meisje. Met ij: vrij, rijden, schrijven. De klanken 'ei' en 'ij' klinken hetzelfde, maar je schrijft ze anders. Dit zijn weetwoorden die je uit je hoofd moet leren.",
        "solutionSteps": [
          "Ei-woorden: trein, klein, meisje",
          "Ij-woorden: vrij, rijden, schrijven",
          "Onthoud: ei en ij klinken hetzelfde — je moet ze uit je hoofd leren"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-008",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "true_false_series",
      "question": "Beoordeel of elk woord correct gespeld is.",
      "data": {
        "statements": [
          { "text": "'Trein' schrijf je met ei.", "isTrue": true },
          { "text": "'Blij' schrijf je met ei.", "isTrue": false },
          { "text": "'Klein' schrijf je met ei.", "isTrue": true },
          { "text": "'Tijd' schrijf je met ei.", "isTrue": false },
          { "text": "'Reis' schrijf je met ei.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ei of ij?", "content": "Ei-woorden: trein, klein, reis, meisje, leiden.\nIj-woorden: blij, tijd, vrij, rijden, schrijven.\n\nOnthoud: ei en ij klinken hetzelfde. Je moet ze uit je hoofd leren.", "icon": "book" } }
      ],
      "conceptId": "ei_ij_tf_series",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Trein → ei ✓, blij → ij (niet ei) ✗, klein → ei ✓, tijd → ij (niet ei) ✗, reis → ei ✓. Onthoud: ei en ij klinken hetzelfde. Je moet de spelling uit je hoofd leren.",
        "solutionSteps": [
          "Trein → ei-woord → klopt ✓",
          "Blij → ij-woord → klopt niet ✗",
          "Klein → ei-woord → klopt ✓",
          "Tijd → ij-woord → klopt niet ✗",
          "Reis → ei-woord → klopt ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-009",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "fill_in",
      "question": "Vul in met ei of ij en typ het hele woord: de conducteur staat in de tr_n.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["trein"],
        "caseSensitive": false,
        "placeholder": "tr...n"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ei of ij?", "content": "'Trein' schrijf je met 'ei'. Dit is een weetwoord uit het rijtje klein, meisje, reis, leiden.", "icon": "book" } }
      ],
      "conceptId": "ei_ij_fill_trein",
      "variantIndex": 9,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Trein' schrijf je met 'ei'. Het hoort in het rijtje ei-woorden: klein, meisje, reis, leiden. Ei en ij klinken hetzelfde — je moet deze weetwoorden uit je hoofd leren.",
        "solutionSteps": [
          "De klank is 'ei/ij' — dit is een weetwoord",
          "'Trein' hoort bij de ei-woorden (klein, meisje, reis)",
          "Dus: trein (met ei)"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-010",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "spelling_pick",
      "question": "Tik bij elk woord aan: ei of ij?",
      "context": "Ei en ij klinken hetzelfde. Je moet deze weetwoorden uit je hoofd leren.",
      "data": {
        "spellingPick": {
          "variant": "ei-ij",
          "words": [
            { "before": "vr", "after": "", "correct": "ij" },
            { "before": "kl", "after": "n", "correct": "ei" },
            { "before": "t", "after": "d", "correct": "ij" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ei of ij?", "content": "Ij-woorden: vrij, tijd, rijden, schrijven, blij. Ei-woorden: klein, trein, meisje, reis. De klank is hetzelfde — leer ze uit je hoofd.", "icon": "book" } }
      ],
      "conceptId": "ei_ij_pick_trio",
      "variantIndex": 10,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Goed gekeken! 'vrij' en 'tijd' schrijf je met ij, 'klein' met ei. Deze weetwoorden klinken hetzelfde, dus moet je ze onthouden.",
        "solutionSteps": [
          "vrij → ij-woord",
          "klein → ei-woord",
          "tijd → ij-woord"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-WEET-EI-IJ-011",
      "familyId": "SPR-WEET-EI-IJ",
      "module": "SpellingRegel",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "weetwoorden",
      "subSkill": "weet_ei_ij",
      "questionType": "spelling_pick",
      "question": "Maak het woord af: ei of ij?",
      "context": "Denk aan de rijtjes met ei- en ij-woorden.",
      "data": {
        "spellingPick": {
          "variant": "ei-ij",
          "words": [
            { "before": "schr", "after": "ven", "correct": "ij" },
            { "before": "m", "after": "sje", "correct": "ei" }
          ]
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Ei of ij?", "content": "'Schrijven' is een ij-woord (net als rijden, blijven). 'Meisje' is een ei-woord (net als klein, trein, reis).", "icon": "book" } }
      ],
      "conceptId": "ei_ij_pick_duo",
      "variantIndex": 11,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Schrijven' schrijf je met ij, 'meisje' met ei. Ei en ij zijn weetwoorden: er is geen regel die je helpt, dus je leert de rijtjes uit je hoofd. Checktruc: hoort het woord bij de ij-rij (vrij, tijd, rijden, schrijven) of de ei-rij (klein, trein, meisje, reis)?",
        "solutionSteps": [
          "schrijven → ij-woord (ij-rij: rijden, blijven, schrijven)",
          "meisje → ei-woord (ei-rij: klein, trein, reis)",
          "Check: weetwoord — leer de rij uit je hoofd"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}